import api, { handleResponse, handleError } from './api';

const featuredWallService = {
  /**
   * Public anonymous endpoint. Returns:
   *   { region, patron, featured: [...], allEvents: [...] }
   */
  async getWall({ region = null, category = null, lat = null, lng = null } = {}) {
    try {
      const params = new URLSearchParams();
      if (region) params.set('region', region);
      if (category) params.set('category', category);
      if (lat != null && lng != null) {
        params.set('lat', String(lat));
        params.set('lng', String(lng));
      }
      // Lets the server drop events whose local date/time has passed.
      params.set('tzOffset', String(new Date().getTimezoneOffset()));
      const response = await api.get(`/featuredwall${params.toString() ? `?${params}` : ''}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Paginated, server-filtered "all events" for the wall's infinite scroll.
   * Returns { events: [...], hasMore: boolean }.
   */
  async getEvents({ lat = null, lng = null, fundingType = null, category = null, cities = null, days = null, search = null, free = false, skip = 0, take = 24 } = {}) {
    try {
      const params = new URLSearchParams();
      if (lat != null && lng != null) { params.set('lat', String(lat)); params.set('lng', String(lng)); }
      if (fundingType && fundingType !== 'all') params.set('fundingType', fundingType);
      if (category) params.set('category', category);
      if (cities && cities.length) params.set('cities', cities.join(','));
      if (days && days.length) params.set('days', days.join(','));
      if (search && search.trim()) params.set('q', search.trim());
      if (free) params.set('free', 'true');
      // JS getTimezoneOffset: lets the server map event UTC starts to the user's
      // local calendar day — for the day filter AND for hiding past events.
      params.set('tzOffset', String(new Date().getTimezoneOffset()));
      params.set('skip', String(skip));
      params.set('take', String(take));
      return handleResponse(await api.get(`/featuredwall/events?${params}`));
    } catch (error) {
      return handleError(error);
    }
  },

  /** Quick check used by the root-route redirect. Returns { hasFeatured: boolean }. */
  async hasAny() {
    try {
      const response = await api.get('/featuredwall/has-any');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default featuredWallService;
